import { urlNotifications } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { INotifications } from '~/utils/interface/notifications';
import { IBaseResponse } from '~/utils/interface/base';

export const notificationApi = {
  getListNotifications() {
    const url = `${urlNotifications.getList}`;
    return axiosClient.get<IBaseResponse<INotifications[]>>(url);
  },
};
